import { Root } from "./Root";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Root />
    </div>
  );
}

export default App;
